// extracted by mini-css-extract-plugin
export default {"base":"kbX86","icon":"ejeKn"};